import { USER_MOBILE } from './types'

export const setUserMobile = (status) => {
  return {
    type: USER_MOBILE,
    payload: status,
  }
}
